import * as d3 from 'd3'
export default {

  methods: {

    draw_Status() {

      let status = this.canvasForms
      .append('g')
      .attr('transform', `translate(0, ${this.status.y})`)

      status
      .append('rect')
      .attr('x', 0).attr('y', 0).attr('rx', this.status.barHeight/2)
      .attr('width', this.status.width).attr('height', this.status.barHeight)
      .attr('fill', '#F4F5F5')


      let total = status
      .append('g')
      .attr('id', `TOT_GROUP_${this.localId}`)
      .attr('transform', `translate(${this.status.width}, -2)`)

      total // Total
      .append('text')
      .attr('id', `TOT_${this.localId}`)
      .attr('x', 0).attr('y', 0)
      .attr('fill', this.status.total.tColor).attr('font-size', this.status.total.tSize)
      .text(this.gmx_numFormat(this.rawData[this.status.totalRef], '$'))

      total // Total
      .append('text')
      .attr('x', this.getNode(`#TOT_${this.localId}`) + 2).attr('y', 0)
      .attr('fill', '#757575').attr('font-size', this.status.total.uSize)
      .text(this.status.total.unit)

      d3.select(`#TOT_GROUP_${this.localId}`).attr('transform', `translate(${this.status.width - this.getNode(`#TOT_GROUP_${this.localId}`)}, -2)`)



      this.columns.forEach(d=> {

        if(d.bar == 'Y') {
          let raWidth = this.status.width * d.ratio
          status
          .append('rect')
          .attr('x', 0).attr('y', 0).attr('rx', 3)
          .attr('width', raWidth).attr('height', 6)
          .attr('fill', d.bColor).attr('stroke-width', 0).attr('opacity', d.opacity)
        }

        // Draw Bullet
        let blt = this.status.bullet
        if(blt.type == 'rect') {
          status
          .append('rect')
          .attr('x', d.sx).attr('y', this.status.name.y)
          .attr('width', blt.width).attr('height', blt.height)
          .attr('fill', d.bColor).attr('stroke-width',0)
        }
        if(blt.type == 'circle') {
          status
          .append('circle')
          .attr('cx', d.sx).attr('cy', this.status.name.y + (this.status.name.tSize/2)).attr('r', blt.width)
          .attr('fill', d.bColor)
        }

        status // Name
        .append('text')
        .attr('x', d.sx + blt.width + 2).attr('y', this.status.name.y + this.status.name.tSize*0.75)
        .attr('fill', this.status.name.tColor).attr('font-size', this.status.name.tSize)
        .attr('text-anchor', 'start')
        .text(d.name)

        status // Value
        .append('text')
        .attr('x', d.sx + 5).attr('y', this.status.value.y + this.status.value.tSize*0.75)
        .attr('fill', this.status.value.tColor).attr('font-size', this.status.value.tSize)
        .attr('text-anchor', 'start')
        .text(this.gmx_numFormat(d.value, '$') + this.status.value.unit)
        .call(this.event_Link, d)

      })

    },

  } 
}